// extracted by mini-css-extract-plugin
export default {"imggall":"Gallerycard_imggall__O-JUI"};